import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {AdvertisedProductsComponent} from './advertised-products.component';
import {BasicModalModule} from '../../shared/modules/modals/basic-modal/basic-modal.module';
import {ButtonModule} from '../../shared/modules/button/button.module';
import {CarouselModule} from '../../shared/modules/carousel/carousel.module';

@NgModule({
  declarations: [AdvertisedProductsComponent],
  imports: [
    CommonModule,
    BasicModalModule,
    ButtonModule,
    CarouselModule,
    RouterModule,
  ],
  exports: [AdvertisedProductsComponent],
})
export class AdvertisedProductsModule { }
